import { useSelector } from "react-redux";

import { getMessagePreviewById } from "utils/message";
import { handleScrollIntoView } from "utils/view";
import useTranslation from "hooks/useTranslation";
import ProgressBar from "components/ProgressBar";
import styles from "./styles.module.scss";

const getLocale = ({ settingsData }) => settingsData.locale;
const getSelectedConversation = ({ chatsData }) =>
  chatsData.selectedConversation;

const VideoMessage = ({ id, url, time, replyId, progress, delivered }) => {
  const locale = useSelector(getLocale);
  const selectedConversation = useSelector(getSelectedConversation);

  const { getTranslation } = useTranslation("COMMON");
  const { t } = getTranslation();

  const handleShowRepliedMessage = () => {
    handleScrollIntoView(replyId);
  };

  const renderProgressIndicator = !delivered &&
    ![null, undefined].includes(progress) && (
      <div className={styles.upload_progress}>
        <ProgressBar
          progress={progress}
          size={85}
          trackColor="#FFF"
          trackWidth={6}
          indicatorWidth={6}
          showPercent={true}
        />
      </div>
    );

  return (
    <div
      data-id={id}
      className="conv__body__body__inner__msgleft__inner__bubble__video "
    >
      {replyId && (
        <div
          dir="auto"
          className="conv__body__body__inner__msgright__inner__bubble__replied_msg"
          onClick={handleShowRepliedMessage}
        >
          <span>
            {getMessagePreviewById(replyId, selectedConversation, locale)}
          </span>
        </div>
      )}
      <div className="video-player">
        <video width={"100%"} height={"100%"} controls preload="none">
          <source src={url} type="video/mp4" />
          <source src={url} type="video/ogg" />
          {t("BROWSER_NOT_SUPPOR_VIDEO_FILES")}
        </video>
        {renderProgressIndicator}
      </div>
    </div>
  );
};

export default VideoMessage;
